export default "__VITE_ASSET__kKYTWBDq__"